import script from "./miniStreamContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./miniStreamContainer.vue?vue&type=script&setup=true&lang=js"

import "./miniStreamContainer.vue?vue&type=style&index=0&id=71d1c18c&scoped=true&lang=css"

import exportComponent from "D:\\works\\淘游虎\\yududs-im\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71d1c18c"]])

export default __exports__